/*
    API Access (static#49) — display names for AWS API Gateway usage plans.

    The usage plan is what actually enforces a customer's rate limit and quota;
    it is AWS state, not Golfbert state, and `GET /api-access` returns only its
    id. This is a display-only mirror so the panel can name it.

    Mirrored from account 611374849314 / us-east-1, verified 2026-08-16. If Dave
    changes a plan's quota in the AWS console, update this table — and do NOT
    copy limits from `planCardData` in utils/data.js, which is marketing copy and
    is currently stale (it advertises 100,000/month for All Courses; the live
    plan is 3,572/day).

    Unknown ids are expected: the call-limit toggle moves a customer between a
    `-capped` and an `-overage` plan, so new ids will appear. Callers must handle
    a null return.
*/
const USAGE_PLANS = {
  ebww69: { name: "Trial", quota: "1,000 calls per week" },
  "0idc4m": { name: "Single Golf Course", quota: "10,000 calls per month" },
  "71z3ep": { name: "All Golf Courses", quota: "3,572 calls per day" },
  "67p3av": { name: "Enterprise", quota: "100,000 calls per month" },
  mnovsd: { name: "Unlimited Quota", quota: "No quota" },
  ljgq1j: { name: "Custom 10 Courses", quota: "60,000 calls per month" },
  // Starter: verified 2026-10-13 (1,000/MONTH, 1/s, burst 50, stage v1).
  yq7p7h: { name: "Starter", quota: "1,000 calls per month" },
  gq2m45: { name: "Powershot", quota: "200,000 calls per month" },
  hiucrn: { name: "Internal use", quota: "No quota" },
  zkwrcx: { name: "Dev plan", quota: "5,000 calls per month" },
};

export const getUsagePlan = (usagePlanId) =>
  (usagePlanId && USAGE_PLANS[usagePlanId]) || null;

export default USAGE_PLANS;
